import { TTotal } from "@/module/common";
import { TGetListId, TRecordListType, TGetDetalisId, TRecordDetailsType, TGetParentId, TRecordMenuType,TGetNodeId,TRecordVideoType,TGetUserCurrId, TUserCurrType } from "@/module/record";
import request from "@/utils/requset";
export const GetItemlist = () => { }

// 获取录播列表
export const getRecordList = (data: TGetListId) => {
    return request<TGetListId, TTotal<TRecordListType[]>>({
        url: '/api/user/structuredirectory/getlastdiclistv2',
        method: 'GET',
        data
    })
}

// 录播视频列表页
export const getRecordVideoList = (data: TGetNodeId) => {
    return request<TGetNodeId, TRecordVideoType[]>({
        url: '/api/user/structurepagecontent/getstructurepagelist',
        method: 'POST',
        data
    })
}

// 录播详情页
export const getRecordDetails= (data: TGetDetalisId) => {
    return request<TGetDetalisId, TRecordDetailsType>({
        url: '/api/user/structurepagecontent/getstructurepagecontentinfo',
        method: 'GET',
        data
    })
}

// 录播目录菜单页
export const getRecordMenu = (data: TGetParentId) => {
    return request<TGetParentId, TRecordMenuType[]>({
        url: '/api/user/structuredirectory/getuserauthstrdiclist',
        method: 'GET',
        data
    })
}

// 首页课程列表
export const getUserCurriculum = (data: TGetUserCurrId) => {
    return request<TGetUserCurrId, TTotal<TUserCurrType[]>>({
        url: '/api/user/structuredirectory/getusercurriculum',
        method: 'GET',
        data
    })
}